import { cx } from '@emotion/css';
import { h3Css, p2Css } from '@snapchat/snap-design-system-marketing';
import type { FC, ReactNode } from 'react';

import {
  alignLeftOnTwoColumnCollapseCss,
  gradientTextCss,
  headerCss,
  headingCss,
  subtitle2Css,
  subtitleSpecificVersionCss,
  subtitleWrapperCss,
  titleSpecificVersionCss,
} from './ArDownloadFormBlock.styles';

interface ArDownloadFormHeaderProps {
  title?: ReactNode;
  supertitle?: ReactNode;
  subtitle: ReactNode;
  version?: string;
  releaseNotesLinkText?: ReactNode;
  forSpecificVersion?: boolean;
}

export const ArDownloadFormHeader: FC<ArDownloadFormHeaderProps> = ({
  title,
  supertitle,
  subtitle,
  version,
  releaseNotesLinkText,
  forSpecificVersion = false,
}) => {
  return (
    <header className={cx(headerCss, 'ar-dowload-form-header')}>
      {supertitle ? (
        <>
          <p
            className={cx(h3Css, headingCss, {
              [alignLeftOnTwoColumnCollapseCss]: forSpecificVersion,
            })}
          >
            {supertitle} {version && !forSpecificVersion && version}
          </p>

          <h1
            className={cx(headingCss, gradientTextCss, {
              [alignLeftOnTwoColumnCollapseCss]: forSpecificVersion,
              [titleSpecificVersionCss]: forSpecificVersion,
            })}
          >
            {title}
          </h1>
        </>
      ) : (
        <h1
          className={cx(headingCss, {
            [alignLeftOnTwoColumnCollapseCss]: forSpecificVersion,
            [titleSpecificVersionCss]: forSpecificVersion,
          })}
        >
          {title}{' '}
          {version && !forSpecificVersion && <span className={gradientTextCss}>{version}</span>}
        </h1>
      )}
      <div className={cx(subtitleWrapperCss)}>
        <span
          className={cx(p2Css, headingCss, {
            [alignLeftOnTwoColumnCollapseCss]: forSpecificVersion,
            [gradientTextCss]: !forSpecificVersion,
            [subtitleSpecificVersionCss]: forSpecificVersion,
          })}
        >
          {subtitle}
        </span>
        {releaseNotesLinkText && (
          <span
            className={cx(p2Css, headingCss, subtitle2Css, {
              [alignLeftOnTwoColumnCollapseCss]: forSpecificVersion,
            })}
          >
            {releaseNotesLinkText}
          </span>
        )}
      </div>
    </header>
  );
};
